<div class="gs-theme home-tabs-root" [class.feed-active]="activeTab==='feed'">

  <!-- Home tab bar -->
  <nav class="home-tabs-bar" role="tablist" aria-label="Home tabs">
    <button type="button"
            role="tab"
            class="home-tab-btn"
            *ngIf="canShowRecruiter"
            [class.active]="activeTab==='recruiter'"
            [attr.aria-selected]="activeTab==='recruiter'"
            (click)="selectTab('recruiter')">
      <ng-icon name="tablerBriefcase" class="gs-ico"></ng-icon> Recruiter Dashboard
    </button>
    <button type="button"
            role="tab"
            class="home-tab-btn"
            *ngIf="canShowBench"
            [class.active]="activeTab==='bench'"
            [attr.aria-selected]="activeTab==='bench'"
            (click)="selectTab('bench')">
      <ng-icon name="tablerUsers" class="gs-ico"></ng-icon> Bench Sales Dashboard
    </button>
    <button type="button"
            role="tab"
            class="home-tab-btn"
            [class.active]="activeTab==='feed'"
            [attr.aria-selected]="activeTab==='feed'"
            (click)="selectTab('feed')">
      <ng-icon name="tablerMessage" class="gs-ico"></ng-icon> Activity Feed
      <!-- <span class="home-tab-new">New</span> -->
    </button>
  </nav>

  <!-- Recruiter Dashboard tab -->
  <app-recruiter-dashboard *ngIf="activeTab==='recruiter' && canShowRecruiter && !reloading"></app-recruiter-dashboard>

  <!-- Bench Sales Dashboard tab -->
  <app-bench-sales-dashboard *ngIf="activeTab==='bench' && canShowBench && !reloading"></app-bench-sales-dashboard>

  <!-- Activity Feed tab — existing landing-page content, restyled three-column layout -->
  <div *ngIf="activeTab==='feed' && !reloading" class="af-grid">

    <!-- LEFT: profile card -->
    <aside class="af-left">
      <app-user-badge></app-user-badge>
    </aside>

    <!-- CENTRE: composer + feed (existing logic untouched) -->
    <main class="af-centre">
      <app-bussiness-post [postView]="'GIG_HOME_PAGE'"></app-bussiness-post>
    </main>

    <!-- RIGHT: invite-colleagues + widget stack.
         `<app-invite-colleagues>` is normal flow — scrolls with the page.
         `.all-page-widget` receives `.sticky-widget-freelancer` /
         `.sticky-widget-other-users` from the scroll handler after 300px
         of scroll. Those classes apply top-anchored CSS sticky
         (`position: sticky; top: 80px;`), so the widgets pin below the
         global nav once the user scrolls into the feed — no layout jump,
         smooth engagement. -->
    <aside class="af-right">
      <app-invite-colleagues></app-invite-colleagues>
      <div class="all-page-widget"
           [class.sticky-widget-freelancer]="freelancer"
           [ngClass]="{'sticky-widget-other-users': otherusertypes}">
        <app-common-widget [page]="'GIG_HOME_PAGE'" [inputData]="'HOME'"  [userType]="'ALL'"></app-common-widget>
        <!-- <app-common-widget [page]="'GIG_JOB_LIST'"  *ngIf=" userType!='FREELANCE_RECRUITER' && userType!='MANAGEMENT_TALENT_ACQUISITION'"   [showflag]="filterApplied" [showsuggJobsData]="showSuggJobsDataServer"
        [inputData]="'GIG_JOB_LIST'"></app-common-widget>

        <app-common-widget [page]="'GIG_JOB_LIST_BOTH'" *ngIf=" userType=='FREELANCE_RECRUITER' || userType=='MANAGEMENT_TALENT_ACQUISITION'"  [showflag]="filterApplied" [showsuggJobsData]="showSuggJobsDataServer"
        [inputData]="'GIG_JOB_LIST_BOTH'"></app-common-widget>

        <app-common-widget *ngIf="userType!='FREELANCE_RECRUITER' && userType!='MANAGEMENT_TALENT_ACQUISITION'"
        [page]="'GIG_CANDIDTAE_LIST'" [showflag]="jobfilter" [showsuggJobsData]="showsuggJobsData"
        [inputData]="'GIG_CANDIDTAE_LIST'"></app-common-widget>
      <app-common-widget *ngIf="userType=='FREELANCE_RECRUITER'|| userType=='MANAGEMENT_TALENT_ACQUISITION'"
        [page]="'GIG_CANDIDTAE_LIST_BOTH'" [showflag]="jobfilter" [showsuggJobsData]="showsuggJobsData"
        [inputData]="'GIG_CANDIDTAE_LIST_BOTH'"></app-common-widget> -->
      </div>
    </aside>

  </div>

</div>
